import { useSyncExternalStore } from "react";
import { usePlatformCapabilities } from "@shared-core/capabilities/context";

/**
 * Below Tailwind's `sm`: a phone. Phrased as a max-width so a platform that
 * cannot answer media queries (tests, Storybook's no-op capabilities) gets
 * the wide layout.
 */
export const PHONE_QUERY = "(max-width: 639.98px)";

/**
 * Whether the screen is phone-width now, and again whenever that changes.
 * For layouts that change shape, not just style (a table drawn as stacked
 * cards): Tailwind's `max-sm:` covers the rest.
 */
export function useIsPhone(): boolean {
  const capabilities = usePlatformCapabilities();
  return useSyncExternalStore(
    (onChange) => capabilities.onMediaQueryChange(PHONE_QUERY, onChange),
    () => capabilities.matchesMediaQuery(PHONE_QUERY),
  );
}
